import React, { useEffect, useRef, useState } from 'react';
import { Spin } from 'antd';
import './PipeMap.scss';
import { mapService } from '../../services/map.service';

function PipeMap() {
  // 地图实例引用
  const mapRef = useRef(null);
  // 加载状态
  const [loading, setLoading] = useState(true);
  // 管网路线图层
  const [pipeLineLayer, setPipeLineLayer] = useState(null);
  // 阀门标记图层
  const [valveMarkerLayer, setValveMarkerLayer] = useState(null);
  
  // 指定的中心点坐标
  const centerCoordinates = { lat: 31.813060000000018, lng: 119.98218628576205 };

  //test1   { lat: 31.769008920326783, lng: 120.01485929022715 }
// 运河花园  119.89640643333837&lat=31.808205913212497
// 常发豪庭 lon=119.98218628576205&lat=31.813060000000018
  // 地图初始化配置
  const getMapOptions = () => {
    if (!window.TMap) {
      console.error("TMap SDK未加载");
      return null;
    }
    return {
      center: new window.TMap.LatLng(centerCoordinates.lat, centerCoordinates.lng),
      zoom: 20,
      maxZoom:25,
      viewMode: "2D",
      baseMap: {
        type: "vector",
        features: ["base", "building2d", "label", "point"],
      },
    };
  };

  // 获取阀门元素并绘制标记
  const fetchAndDrawValveMarkers = async () => {
    try {
      if (!mapRef.current) return;
      
      const map = mapRef.current;
      const { lng, lat } = centerCoordinates;
      
      // 调用获取元素列表的接口，获取阀门数据(type=5)
      const response = await mapService.getElementListByGeo(
        lng,  // 经度
        lat,  // 纬度
        200, // 搜索半径，单位米
        null,  // 版本
        5 // 类型，阀门类型为5
      );
      
      // 检查返回数据
      if (response && response.data && response.data.length > 0) {
        // 清除已有的阀门标记图层
        if (valveMarkerLayer) {
          valveMarkerLayer.setMap(null);
        }
        
        // 准备阀门标记数据
        const markerGeometries = [];
        
        response.data.forEach((item, index) => {
          if (item.wgs84_lon && item.wgs84_lat) {
            // 将WGS84坐标转换为腾讯地图坐标
            const position = new window.TMap.LatLng(item.wgs84_lat, item.wgs84_lon);
            
            // 添加到标记几何数据中
            markerGeometries.push({
              id: `valve_${index}`,
              styleId: 'valve_style',
              position: position
            });
          }
        });
        
        // 创建阀门标记样式
        const markerStyle = {
          'valve_style': new window.TMap.MarkerStyle({
            width: 12,
            height: 12,
            anchor: { x: 6, y: 6 },
            src: 'https://cdn.czwatersystem.com/valves_temp.png'
          })
        };
        
        // 创建阀门标记图层
        const newValveMarkerLayer = new window.TMap.MultiMarker({
          id: 'valve_marker_layer',
          map: map,
          styles: markerStyle,
          geometries: markerGeometries
        });
        
        // 保存阀门标记图层引用
        setValveMarkerLayer(newValveMarkerLayer);
        
        console.log(`成功绘制${markerGeometries.length}个阀门标记`);
      } else {
        console.log('未获取到阀门数据或数据为空');
      }
    } catch (error) {
      console.error('获取或绘制阀门标记失败:', error);
    }
  };

  // 获取管网元素并绘制路线
  const fetchAndDrawPipeLines = async () => {
    try {
      if (!mapRef.current) return;
      
      const map = mapRef.current;
      const { lng, lat } = centerCoordinates;
      
      // 调用获取元素列表的接口
      const response = await mapService.getElementListByGeo(
        lng,  // 经度
        lat,  // 纬度
        200, // 搜索半径，单位米
        null,  // 版本
        11 // 类型，这里假设为管道类型
      );
      
      // 检查返回数据
      if (response && response.data && response.data.length > 0) {
        // 清除已有的路线图层
        if (pipeLineLayer) {
          pipeLineLayer.setMap(null);
        }
        
        // 准备路线数据
        const lineGeometries = [];
        
        response.data.forEach((item, index) => {
          if (item.geometry_gcj02_paths && item.geometry_gcj02_paths.length > 0) {
            // 将坐标数组转换为TMap.LatLng对象数组
            const path = [];
            for (let i = 0; i < item.geometry_gcj02_paths.length; i++) {
              const coord = item.geometry_gcj02_paths[i];
              const latLng = new window.TMap.LatLng(coord[1], coord[0]);
              path.push(latLng);
            }
            // 添加到路线几何数据中
            lineGeometries.push({
              id: `line_${index}`,
              styleId: 'pipe_style',
              paths: path
            });
          }
        });

        
        // 创建路线样式
        const lineStyle = {
          'pipe_style': new window.TMap.PolylineStyle({
            color: '#3777FF', // 蓝色
            width: 1,         // 宽度从5减小到2
            borderWidth: 0.5,   // 边框宽度从1减小到0.5
            borderColor: '#3777FF', // 边框颜色
            lineCap: 'round'  // 线帽样式
          })
        };
        
        // 创建路线图层
        const newPipeLineLayer = new window.TMap.MultiPolyline({
          id: 'pipe_line_layer',
          map: map,
          styles: lineStyle,
          geometries: lineGeometries
        });
        
        // 保存路线图层引用
        setPipeLineLayer(newPipeLineLayer);
        
        console.log(`成功绘制${lineGeometries.length}条管网路线`);
      } else {
        console.log('未获取到管网数据或数据为空');
      }
    } catch (error) {
      console.error('获取或绘制管网路线失败:', error);
    }
  };

  useEffect(() => {
    let map = null;
    let initAttempts = 0;
    const maxAttempts = 3;

    const initMap = async () => {
      try {
        // 确保SDK已加载
        if (!window.TMap) {
          if (initAttempts < maxAttempts) {
            console.log(`等待SDK加载，尝试次数: ${initAttempts + 1}`);
            initAttempts++;
            setTimeout(initMap, 500);
            return;
          }
          throw new Error("TMap SDK加载超时");
        }

        // 检查是否已存在地图实例
        const existingMap = document.querySelector(
          "#pipe-map-container .tmap-container"
        );
        if (existingMap) {
          console.log("地图实例已存在，跳过初始化");
          return;
        }

        const options = getMapOptions();
        if (!options) {
          throw new Error("无法获取地图配置");
        }

        // 初始化地图
        map = new window.TMap.Map("pipe-map-container", options);
        mapRef.current = map; // 保存地图实例引用
        
        // 移除旋转控件
        map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.ROTATION);
        
        // 设置比例尺控件位置
        map
          .getControl(window.TMap.constants.DEFAULT_CONTROL_ID.SCALE)
          .setPosition(window.TMap.constants.CONTROL_POSITION.TOP_CENTER);
        
        // 设置缩放控件位置
        map
          .getControl(window.TMap.constants.DEFAULT_CONTROL_ID.ZOOM)
          .setPosition(window.TMap.constants.CONTROL_POSITION.BOTTOM_RIGHT);

        // 创建中心点标记
        const centerMarker = new window.TMap.MultiMarker({
          map: map,
          styles: {
            center: new window.TMap.MarkerStyle({
              width: 25,
              height: 25,
              anchor: { x: 12.5, y: 12.5 },
              src: "https://cdn.czwatersystem.com/static_res/location_dot_center.png",
            }),
          },
          geometries: [
            {
              id: "center_marker",
              styleId: "center",
              position: new window.TMap.LatLng(
                centerCoordinates.lat,
                centerCoordinates.lng
              ),
            },
          ],
        });

        // 地图加载完成后关闭加载状态
        setLoading(false);
        
        // 地图加载完成后获取并绘制管网路线
        fetchAndDrawPipeLines();
        
        // 地图加载完成后获取并绘制阀门标记
        fetchAndDrawValveMarkers();

      } catch (error) {
        console.error("地图初始化失败:", error);
        setLoading(false);
      }
    };

    // 检查是否已加载腾讯地图SDK
    if (!document.querySelector('script[src*="map.qq.com/api/gljs"]')) {
      // 如果没有加载，创建并添加脚本
      const script = document.createElement("script");
      script.src = "https://map.qq.com/api/gljs?v=1.exp&key=6C4BZ-LVJCQ-OZX55-BDMBZ-W5QMZ-E7BTZ";
      script.async = true;
      script.onload = initMap;
      document.head.appendChild(script);
    } else {
      // 如果已加载，直接初始化地图
      initMap();
    }

    // 组件卸载时清理
    return () => {
      if (map) {
        // 清理地图实例（如果腾讯地图API提供了销毁方法）
        // map.destroy();
      }
      
      // 清理路线图层
      if (pipeLineLayer) {
        pipeLineLayer.setMap(null);
      }
      
      // 清理阀门标记图层
      if (valveMarkerLayer) {
        valveMarkerLayer.setMap(null);
      }
    };
  }, []);

  return (
    <div className="pipe-map-container">
      <h1>管网地图</h1>
      <div className="pipe-map-content">
        {loading && (
          <div className="loading-container">
            <Spin size="large" tip="地图加载中..." />
          </div>
        )}
        <div id="pipe-map-container" style={{ width: '100%', height: '100%' }}></div>
      </div>
    </div>
  );
}

export default PipeMap;